import { useContext } from "react"
import { Context } from "../store/store"

interface WinHeaderCopyProps {
	debugWin?: any
}

const WinHeaderCopy: React.FC<WinHeaderCopyProps> = ({ debugWin = null }) => {
	const { globalState } = useContext(Context)

	const content = {
		1: "nimm2  Lachgummi  Produktpaket",
		2: "nimm2  Lachgummi  Liegestuhl",
		3: (
			<>
				nimm2 Sommer Hit Strandtasche & <br />
				nimm2 soft Splash Beachball Set
			</>
		),
		4: "nimm2  Produktpaket",
		5: "American   Tourister Koffer",
		6: "nimm2 Lachgummi  Apfellinge Luftmatratze",
		7: "nimm2  Lachgummi Picknickdecke",
	}

	if (debugWin === 0) {
		debugWin = 7
	}

	console.log(debugWin)

	if (content[debugWin ? debugWin : globalState.raffledPrizeCode]) {
		return <h2 className="h2 calenderCopyShadow lg:text-left mb-[40vw] md:mb-[200px]">{content[debugWin ? debugWin : globalState.raffledPrizeCode]}</h2>
	} else {
		return null
	}
}
export default WinHeaderCopy
